import React, { useEffect, useState, useContext } from "react";
import "./style.css";
import { Title } from "../../Components/Atoms";

import { getDriverOrVehicleStats, getVehiclesInfo} from "../../APIs";
import { MANUFATURING_CO2_EMISSION_PER_KM, CO2_EMISSION_PER_KM, ONE_DAY_MS } from "../../Library/constants";

import { Checkbox } from '@chakra-ui/react';
import { StoreContext } from "../../Library/contexts";

const OVERALL_STATS = [
  { key: "yesterday", label: "Yesterday" },
  { key: "month", label: "This Month" },
  { key: "year", label: "This year" },
];

const CarbonStats = () => {
  const [ allVehicleStats, setAllVehicleStats ] = useState([]);

  const [ overallStats, setOverallStats ] = useState({ yesterday: 0, month: 0, year: 0 });
  const [ updateCarbonEmissionConstant, setUpdateCarbonEmissionConstant ] = useState(false);

  const { filters } = useContext(StoreContext);

  useEffect(() => {
    if (!filters.client) return;

    const startOfCurrentYear = new Date(new Date().getFullYear(), 0, 1).getTime();
    getVehiclesInfo(filters.client, null, (err, resp) => {
      if (err) console.log(err)
      else {
        if (resp && resp.length) {
          getDriverOrVehicleStats(resp.map(veh => veh.idx), null, { from: startOfCurrentYear, to: new Date().setHours(23, 59, 59, 999) }, (err, stats) => {
            if (err) console.log(err)
            else {
              setAllVehicleStats(stats);
              calculateStats(stats, CO2_EMISSION_PER_KM);
            }
          });
        }
      }
    });
  }, [ filters.client ])

  const calculateStats = (stats, carbonEmissionConstant) => {
    let date = new Date().setHours(0, 0, 0, 0);
    let currentDate = new Date();

    let yesterday = 0;
    let month = 0;
    let year = 0;

    let yesterdaySavings = {};
    let monthlySavings = {};
    let yearlySavings = {};

    (stats.dayWiseStats || []).forEach(stat => {
      if (stat.ts >= (date - ONE_DAY_MS)) {
        if (!yesterdaySavings[stat.vid]) yesterdaySavings[stat.vid] = 0;
        yesterdaySavings[stat.vid] += (stat.dst * carbonEmissionConstant);
      }

      if (stat.ts > (new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getTime())) {
        if (!monthlySavings[stat.vid]) monthlySavings[stat.vid] = 0;
        monthlySavings[stat.vid] += (stat.dst * carbonEmissionConstant);
      }
    });

    (stats.monthlyStats || []).forEach(stat => {
      if (!yearlySavings[stat.vid]) yearlySavings[stat.vid] = 0;
      yearlySavings[stat.vid] += (stat.dst * carbonEmissionConstant);
    });

    yesterday = Object.values(yesterdaySavings);
    month = Object.values(monthlySavings);
    year = Object.values(yearlySavings);

    let thisMonthStats = month.length ? month.reduce((saving1, saving2) => saving1 + saving2, 0).toFixed(2) : 0;
    let yearStats = year.length ? year.reduce((saving1, saving2) => saving1 + saving2, 0).toFixed(2) : 0;
    let thisYearStats = Number(yearStats) + Number(thisMonthStats);

    setOverallStats({
      yesterday: yesterday.length ? yesterday.reduce((saving1, saving2) => saving1 + saving2, 0).toFixed(2) : 0,
      month: month.length ? month.reduce((saving1, saving2) => saving1 + saving2, 0).toFixed(2) : 0,
      year: thisYearStats,
    });
  }

  const handleEmissionConstantChange = () => {
    calculateStats(allVehicleStats, !updateCarbonEmissionConstant ? MANUFATURING_CO2_EMISSION_PER_KM : CO2_EMISSION_PER_KM)

    setUpdateCarbonEmissionConstant(!updateCarbonEmissionConstant)
  }

  return (
    <div className="panel-main carbon-stats">
      <div className="carbon-stats-widget-header">
        <Title>CO₂ Emission saved</Title>
        <Checkbox onChange={handleEmissionConstantChange} isChecked={updateCarbonEmissionConstant} className='carbon-emission-widget-checkbox' colorScheme='purple'>
          Include Emission saved during manufacturing
        </Checkbox>
      </div>
      <div className="carbon-emission-overall-stats">
        { OVERALL_STATS.map((stats, idx) => (
          <React.Fragment key={idx}>
            <label>
              <p className="label">{stats.label}</p>
              <p>{ Number(overallStats[stats.key] || "0").toLocaleString("en-IN") }kgs</p>
            </label>
            {(idx !== (OVERALL_STATS.length - 1)) ? <div className="stat-box-seperator" /> : null}
          </React.Fragment>
        )) }
      </div>
    </div>
  )
}

export default CarbonStats